import { Radio } from 'antd';
import styled from 'styled-components';

export default styled(Radio.Button)`
	// Add your styles here
`;
